export interface ModalData {
    title: string;
    msg: string;
    showremarks ?: boolean;
    remarks ?: string;
}

export interface VoiceModalData {
    title: string;
    msg: string;
    showRadioButton: boolean;
    radioOptions:[
        {label: string,value: string},
        {label: string,value: string}   
    ];
  selectOption:boolean  
  selectedmessage:string
  remarks: string
  getselect(selectedvalue):void;
}

//PETMBinding - TATMTD Side Surekha
export interface petmbindingData {
    title: string;
    msg: string;
    showRadioButton: boolean;
        radioOptions:[
        {label: string,value: string},
        {label: string,value: string}   
    ];
    showjustification: boolean
  selectOption:boolean 
  nextentityid :string
  selectedmessage:string
  remarks: string
  justification: string
  getselect(selectedvalue):void;
}

export interface options{
    title:string;
    msg:string;
}

export const ErrModalData: ModalData = {
    title: 'Error',
    msg: 'Error Occured'
};
export const SuccModalData: ModalData = {
    title: 'Success',
    msg: 'Success'
};
export const PromptModalData: ModalData = {
    title: 'Prompt',
    msg: 'Are you sure yes / No ?',
    remarks: ''
};

export const PromptVoiceModalData: VoiceModalData = {
    title: 'Prompt',
    msg: 'Are you sure yes / No ?',
    showRadioButton: false,
    radioOptions:[
        {label:'yes',value:'yes'},
        {label:'yes',value:'yes'}
        ],
        selectOption:true,
        selectedmessage:'',
        remarks: '',
        getselect(selectedvalue:string){
            selectedvalue = 'yes'
            this.selectedOption=true;
            this.selectedmessage=selectedvalue==='yes'?'hii':'hello'
            console.log("--------data-------------------------",this.selectedmessage)
        }
};

//PETMBinding - TATMTD Side Surekha
export const PromptPETMBindingModalData: petmbindingData = {
    title: 'Prompt',
    msg: 'Are you sure yes / No ?',
    showRadioButton: false,
    radioOptions:[
        {label:'yes',value:'yes'},
        {label:'yes',value:'yes'}
        ],
        showjustification: false,
        selectOption:true,
        selectedmessage:'',
        remarks: '',
        justification: '',
        nextentityid:'',
        getselect(selectedvalue:string){
            selectedvalue = 'yes'
            this.selectedOption=true;
            this.selectedmessage=selectedvalue==='yes'?'hii':'hello'
            console.log("--------data-------------------------",this.selectedmessage)
        }
};

export const PromptoptionsData : options={
    title: "selected option",
    msg: "do you want to continue"
}

export interface VoiceHdrAuditDataModal {
    title: string;
    voicehdrdata: any;
}

export const VoiceHdrAuditData : VoiceHdrAuditDataModal = {
    title: "Voice Header Audit Logs",
    voicehdrdata: [{"vhurn":"100001","peid":"100001"}]
}